import { getFormattedVariants, SIZE_TYPE } from './getFormattedGoogleImages';

function getImage(url, variants = []) {
  if (variants?.length) {
    return getFormattedVariants(variants);
  }

  return {
    [SIZE_TYPE.SMALL]: {
      url
    }
  };
}

export function getFormattedManualImages(images) {
  return images.map(({ id, provider, file = {}, ...params }, index) => {
    const fileURL = file.data?.url || file.data?.file_url;
    const currentID = id || index;

    if (provider === 'google-photos') {
      return {
        ...params,
        id: currentID,
        image: getImage(fileURL, file.variants),
        isEmpty: !fileURL
      };
    }

    return {
      ...params,
      id: currentID,
      image: { large: { ...file, url: fileURL } },
      isEmpty: !fileURL
    };
  });
}
